export default {"src":"/_next/static/media/woolf-mini-logo.85bde25e.svg","height":35,"width":54};